export default __webpack_public_path__ + "static/button-play-store@2x-7838cab38653b9303425e7ab7f54b252.png";